var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from 'lit-element';
import { openModal } from '../helpers/modal';
import '../components/product-added-modal';
import cart from '../services/cart';
let CartAdd = class CartAdd extends LitElement {
    constructor() {
        super();
        this.sku = '';
        this.quantity = 1;
        this.capacity = '';
        this.unitPrice = '';
        this.productAsGift = false;
        this.gift = false;
        this.productID = '0';
        this.error = null;
        this.altshopID = '1';
        this.logUrl = null;
        this.reloadNoModal = '0';
        this.errorHideTimeout = null;
        this.addedHideTimeout = null;
        this.addEventListener('click', (e) => {
            this.add(e).catch((err) => {
                console.error('Failed to handle click', err);
            });
        });
    }
    static get styles() {
        return css `
            :host {
                position: relative;
                user-select: none;
                height: 100%;
                background-color: var(--color-important-accents);
                color: #fff;
                text-align: center;
                font-weight: bold;
                display: block;
                padding: 0 1em;
                margin: 0;
                width: auto;
                cursor: pointer;
                transition: background-color 0.3s ease-out;
            }
            @media (any-hover) {
                :host(:hover) {
                    background-color: var(--color-important-accents-dark);
                }
            }
            .error {
                width: 100%;
                position: absolute;
                left: 0;
                bottom: 100%;
                margin-bottom: 0.5em;
                background: var(--color-important-accents-dark);
                color: var(--inverse-font-color);
                font-weight: bold;
                font-size: 0.8em;
                border-radius: 1em;
                padding: 0.5em;
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
                z-index: 2;
                box-sizing: border-box;
            }
        `;
    }
    render() {
        return html `
            <div>
                <slot></slot>
                ${this.error !== null ? html ` <div class="error">${this.error}</div> ` : ''}
            </div>
        `;
    }
    async add(e) {
        this.error = null;
        if (this.errorHideTimeout !== null) {
            clearTimeout(this.errorHideTimeout);
        }
        if (this.addedHideTimeout !== null) {
            clearTimeout(this.addedHideTimeout);
        }
        e.preventDefault();
        try {
            if (this.logUrl) {
                // dodaj do urla parametr tag z wartościa add_to_cart
                const url = new URL(this.logUrl);
                url.searchParams.append('tags', JSON.stringify(['add_to_cart']));
                await fetch(url.toString());
            }
            const response = await cart.add(this.sku, this.quantity, {
                productAsGift: this.productAsGift,
                gift: this.gift,
            });
            if (this.reloadNoModal == '1') {
                document.location.reload();
                return;
            }
            else {
                openModal(`
                    <div class="header close-only">
                        <button class="close" data-micromodal-close></button>
                    </div>
                    <div class="content product-added-modal">
                        <product-added-modal sku="${this.sku}"
                            productID="${this.productID}"
                            altshopID="${this.altshopID}"
                            quantity="${this.quantity}"
                            capacity="${this.capacity}"
                            unitPrice="${this.unitPrice}"
                            promotionPrice="${response.promotion_price}"
                            ${this.productAsGift ? 'productAsGift="1"' : ''}
                            >
                        </product-added-modal>
                    </div>
                `);
            }
        }
        catch (e) {
            if (e instanceof Error) {
                this.error = e.message;
                this.errorHideTimeout = setTimeout(() => {
                    this.error = null;
                }, 3000);
            }
            return;
        }
    }
};
__decorate([
    property({ type: String })
], CartAdd.prototype, "sku", void 0);
__decorate([
    property({ type: Number })
], CartAdd.prototype, "quantity", void 0);
__decorate([
    property({ type: String })
], CartAdd.prototype, "capacity", void 0);
__decorate([
    property({ type: String })
], CartAdd.prototype, "unitPrice", void 0);
__decorate([
    property({ type: Boolean })
], CartAdd.prototype, "productAsGift", void 0);
__decorate([
    property({ type: Boolean })
], CartAdd.prototype, "gift", void 0);
__decorate([
    property({ type: String })
], CartAdd.prototype, "productID", void 0);
__decorate([
    property({ type: String })
], CartAdd.prototype, "error", void 0);
__decorate([
    property({ type: String })
], CartAdd.prototype, "altshopID", void 0);
__decorate([
    property({ type: String })
], CartAdd.prototype, "logUrl", void 0);
__decorate([
    property({ type: String })
], CartAdd.prototype, "reloadNoModal", void 0);
CartAdd = __decorate([
    customElement('cart-add')
], CartAdd);
export default CartAdd;
